<div
    class="datiq-cell-label font-body-2"
    [attr.data-testid]="settings.id"
    [ngClass]="{ 'opacity-20': disabled, 'flex-row-reverse pr-6': settings?.align === 'right' }"
>
    <ng-container *ngIf="settings?.icon">
        <mat-icon
            [attr.data-testid]="settings.id + '-icon'"
            class="datiq-cell-label__icon"
            [ngClass]="settings?.iconColor"
            svgIcon="{{ settings?.icon }}"
        ></mat-icon>
    </ng-container>
    <ng-container *ngIf="!settings?.hideLabel">
        <div
            class="datiq-cell-label__container overflow-x-auto"
        >
            <div
                datiqTruncate
                (datiqTruncateEllipsed)="isTruncated = $event"
                [matTooltip]="settings?.label"
                [matTooltipDisabled]="!isTruncated"
                class="datiq-cell-label__label"
                [ngClass]="{
                    'font-bold': settings?.strong
                }"
                [attr.data-testid]="settings?.id + '-label'"
                style="text-wrap: nowrap;"
            >
                {{ settings?.label }}
            </div>
            <ng-container *ngIf="!!settings?.subLabel?.length">
                <div
                    [attr.data-testid]="settings?.id + '-sublabel'"
                    class="datiq-cell-label__sub-label font-body-2 truncate"
                >
                    {{ settings?.subLabel }}
                </div>
            </ng-container>
        </div>
    </ng-container>
</div>
